import { EditIndustryAutomationTemplateCanvas } from '../../containers/templates/EditIndustryAutomationTemplateCanvas';

export function AdminIndustryAutomationCanvasPage() {
	return <EditIndustryAutomationTemplateCanvas />;
}
